import React from 'react';
import { motion } from 'framer-motion';
import { Watermark } from './Watermark';
export function Description() {
  return <section className="relative overflow-hidden py-24 px-6 bg-nude-light" data-id="element-87" data-mp="1heys3q96qlob">
      <Watermark position="right" size={750} opacity={0.05} data-id="element-88" data-mp="1v7eo473o5jfq" />
      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-89" data-mp="1v8zk815mtafp">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-90" data-mp="1r638mueieel9">
          <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-91" data-mp="1chyodlzt5v0d">
            La Experiencia Alexa Beauty
          </span>
          <h2 className="text-3xl md:text-5xl font-serif text-luxury-black mb-10 leading-tight" data-id="element-92" data-mp="2nv130bickahw">
            MÁS QUE UN KIT… <br className="hidden md:block" data-id="element-93" data-mp="2ivpkoy2c0wy7" />
            <span className="italic text-gray-500" data-id="element-94" data-mp="2iz3li1vcky3j">UNA IMAGEN PROFESIONAL</span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-600 font-sans font-light leading-relaxed" data-id="element-95" data-mp="4tyu8badnsbo">
            <p data-id="element-96" data-mp="8vbv06ym55bq">
              Nuestros kits Alexa Beauty fueron creados para mujeres
              profesionales que desean trabajar organizadas, verse elegantes y
              ofrecer una mejor experiencia a sus clientas.
            </p>
            <p data-id="element-97" data-mp="3ha2fjzgrlo60">
              Cada detalle fue pensado para combinar funcionalidad, belleza y
              presencia profesional.
            </p>
            <p className="font-medium text-luxury-black" data-id="element-98" data-mp="3m6b0xulk2dlm">
              No solo compras accesorios… compras presentación, comodidad y
              estilo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}